export default __webpack_public_path__ + "static/media/Floor2MintTowerBuildingMain.4f45b60e.svg";